import { makeActionCreator } from '../../config/store/utils'
import { getBiddingsDistribution } from '../../services/charts'

export const BIDDINGSDISTRIBUTION = 'BIDDINGSDISTRIBUTION'
export const BIDDINGSDISTRIBUTION_ERROR = 'BIDDINGSDISTRIBUTION_ERROR'
export const BIDDINGSDISTRIBUTION_SUCCESS = 'BIDDINGSDISTRIBUTION_SUCCESS'
export const onBiddingsDistribution = makeActionCreator(BIDDINGSDISTRIBUTION)
export const onBiddingsDistributionError = makeActionCreator(BIDDINGSDISTRIBUTION_ERROR, 'payload')
export const onBiddingsDistributionSuccess = makeActionCreator(BIDDINGSDISTRIBUTION_SUCCESS, 'payload')
export const onBiddingsDistributionThunk = (year, idEntity, type) => async dispatch => {
  dispatch(onBiddingsDistribution())

  try {
    // FIXME: there is no support from the endpoint for a percentage type (4).
    const response = await getBiddingsDistribution({ idEntity, year, type })

    if (response.data.success !== 'OK') {
      return dispatch(onBiddingsDistributionError(response.data.errores))
    }

    const resPayload = response.data.payload
    const singlePayload = resPayload.find(item => item.year === year)
    const chartStructure = singlePayload.data.filter((v, i, a) => {
      return a.findIndex(t => t.type === v.type && t.quantityOrders === v.quantityOrders) === i
    })
    const headersByType = {
      1: 'Monto transado (CLP)',
      2: 'Nº licitaciones adjudicadas',
      3: 'Nº órdenes de compra'
    }
    const dataByType = {
      1: 'amount',
      2: 'quantiyBiddings',
      3: 'quantityOrders'
    }
    const csvStructure = [
      ['Año', 'Nombre', headersByType[type], 'Monto porcentual'],
      ...singlePayload.data.map(item => {
        return [year, item.name, item[dataByType[type]], item.percentage]
      })
    ]
    const payload = { chartStructure, csvStructure }

    return dispatch(onBiddingsDistributionSuccess(payload))
  } catch (error) {
    return dispatch(onBiddingsDistributionError(error))
  }
}
